module.exports = __webpack_public_path__ + "static/img/hubiC.536379b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/hubiC.svg
// module id = gPHY
// module chunks = 2